export default __webpack_public_path__ + "static/schedule-prescriber-0f497e322ed2c749f368bfdf7c6648a6.webp";